import { RepositoryFactory } from '../../RepositoryFactory';
import Vue from 'vue';
const classes = new RepositoryFactory('classes');

export default {
  namespaced: true,
  state: {
    // Single class
    class: {
      id: null,
      name: '',
    },
    allClasses: [],
    classes: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
  },
  getters: {
    getClass(state) {
      return state.class;
    },
    getClasses(state) {
      return state.classes;
    },
    getAllClasses(state) {
      return state.allClasses;
    },
    getClassesTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
  },
  mutations: {
    SET_CLASS(state, data) {
      state.class = data;
    },
    SET_CLASSES(state, data) {
      state.classes = data.items;
      state.total = data.totalOfItems;
      // state.itemCount = data.itemCount;
      state.totalPages = data.pageCount;
    },
    SET_ALLCLASSES(state, data) {
      state.allClasses = data;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('getClasses');
    },
    resetPagination: async ({ commit, dispatch }) => {
      commit('SET_PAGE', 1);
      dispatch('getClasses');
    },
    update: async ({ dispatch }, payload) => {
      try {
        await classes.update(payload.id, payload.params);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Classe atualizada com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getClasses');
    },
    remove: async ({ dispatch }, id) => {
      try {
        const { data } = await classes.delete(id);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Classe removida com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getClasses');
    },
    create: async ({ commit, dispatch }, payload) => {
      try {
        await classes.create(payload);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Classe criada com sucesso!',
        });
        dispatch('getClasses');
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
    },
    getClassById: async ({ commit }, id) => {
      try {
        const { data } = await classes.getById(id);
        commit('SET_CLASS', data);
      } catch (error) {}
    },
    getClasses: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await classes.get(state.currentPage);
        commit('SET_CLASSES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getAllClasses: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await classes.get();
        commit('SET_ALLCLASSES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    searchClass: async ({ commit }, search) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await classes.getWithSearch(search);
        commit('SET_CLASSES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
